import { useEffect } from "react";

import { useAppDispatch } from "@/hooks/redux";
import { initServerSocketConnection } from "@/store/reducers/serverConnection/asyncActionCreators";

const useStandSettings = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(initServerSocketConnection());
  }, [dispatch]);
};

export default useStandSettings;
